import { addDays, addMonths, firstOfMonth, todayIn } from '@njpos/core';

export interface Range { from: string; to: string }

export const thisMonth = (): Range => { const t = todayIn(); return { from: firstOfMonth(t), to: t }; };

/** From and to dates with the usual shortcuts. */
export default function DateRange({ value, onChange }: { value: Range; onChange: (r: Range) => void }) {
  const t = todayIn();
  const m = firstOfMonth(t);
  const q = `${t.slice(0, 4)}-${String(Math.floor((Number(t.slice(5, 7)) - 1) / 3) * 3 + 1).padStart(2, '0')}-01`;
  const presets: [string, Range][] = [
    ['This month', { from: m, to: t }],
    ['Last month', { from: addMonths(m, -1), to: addDays(m, -1) }],
    ['This quarter', { from: q, to: t }],
    ['This year', { from: `${t.slice(0, 4)}-01-01`, to: t }],
    ['Last year', { from: `${Number(t.slice(0, 4)) - 1}-01-01`, to: `${Number(t.slice(0, 4)) - 1}-12-31` }],
  ];
  return (
    <div className="row wrap" style={{ gap: 8, alignItems: 'end' }}>
      <label>From<input type="date" value={value.from} onChange={(e) => e.target.value && onChange({ ...value, from: e.target.value })} /></label>
      <label>To<input type="date" value={value.to} onChange={(e) => e.target.value && onChange({ ...value, to: e.target.value })} /></label>
      {presets.map(([l, r]) => <button key={l} className="ghost" onClick={() => onChange(r)}>{l}</button>)}
    </div>
  );
}

/** Saves rows as a CSV file the owner can open in Excel or hand to an accountant. */
export function downloadCsv(name: string, rows: (string | number | null)[][]) {
  const esc = (v: string | number | null) => { const s = v == null ? '' : String(v); return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; };
  const url = URL.createObjectURL(new Blob([rows.map((r) => r.map(esc).join(',')).join('\r\n')], { type: 'text/csv' }));
  const a = document.createElement('a'); a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
